export function setFormHandler(form, key, data) {
  form[key] = data;
}